<template>
  <LayoutSearchFieldVertical>
    <div class="search-field-exist">
      <div class="field">
        <BaseCheckbox v-model="value">
          {{
            lst({ ja: '{}が存在する', en: 'Has values on {}' }, ls(field.name))
          }}
        </BaseCheckbox>
      </div>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { lst, ls } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const value = computed({
  get: () => {
    return props.ss.state.exists.includes(props.field.key)
  },
  set: v => {
    if (v) {
      if (!props.ss.state.exists.includes(props.field.key))
        props.ss.state.exists.push(props.field.key)
    } else {
      removeFromArray(props.ss.state.exists, props.field.key)
    }
    props.ss.execute()
  },
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-field-exist {
  .field {
    display: flex;
    align-items: center;
  }
}
</style>
